<script setup lang="ts">
import { useBrowserSession } from '@/helpers/browser_session'
import { useAuthUser } from '@/helpers/globals'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'

const modelValue = defineModel<boolean>()

withDefaults(
    defineProps<{
        loading: boolean
        msg: string | null
    }>(),
    {
        loading: false,
        msg: null,
    },
)

const emit = defineEmits<{
    (e: 'update:model-value', id: boolean): void
    (e: 'close'): void
}>()

const dontshowanymore = ref(false)
const benutzer = useAuthUser()
const router = useRouter()

watch(dontshowanymore, (value) => {
    save(value)
})

function onProfile() {
    router.push('adressen/profil')
    emit('close')
}

function save(value: boolean) {
    useBrowserSession('').setSessionValue('noWelcomeDlg_' + benutzer?.id, value)
}
</script>

<template>
    <v-dialog
        v-model="modelValue"
        persistent
        :max-width="600"
        @click:outside="$emit('update:model-value', false)"
    >
        <v-card>
            <slot name="title">
                <v-card-title class="headline">{{ $t('welcome') }}</v-card-title>
            </slot>
            <slot>
                <v-card-text>{{ msg }}</v-card-text>
            </slot>
            <slot name="actions">
                <v-card-actions>
                    <v-checkbox
                        v-model="dontshowanymore"
                        class=""
                        :label="$t('dont_show_anymore')"
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-btn color="decline" text :loading="loading" @click="$emit('close')">
                        {{ $t('cancel') }}
                    </v-btn>
                    <v-btn color="action white--text" variant="flat" :disabled="loading" @click="onProfile">
                        {{ $t('edit_profile') }}
                    </v-btn>
                </v-card-actions>
            </slot>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.v-card__text,
.v-card__title {
    word-break: normal !important;
}
</style>
